import React from "react";
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';  // Import useNavigate
import AppLayout from "../../components/AppLayout/AppLayout";
import AddExpense from "../../components/AddExpense/AddExpense";

const AddExpenses = () => {
  const navigate = useNavigate();  // Initialize useNavigate hook

  // Function to handle the event after an expense is added
  const handleExpenseAdded = () => {
    navigate('/my-expenses');  // Navigate to '/my-expenses' page
  };

  return (
    <AppLayout>
      <Grid container justifyContent="center">
        <Grid item xs={10.8}>
          <AddExpense onExpenseAdded={handleExpenseAdded} />
        </Grid>
      </Grid>
    </AppLayout>
  );
};

export default AddExpenses;
